export default "__VITE_ASSET__b116ea3e__"